export default __webpack_public_path__ + "static/media/FUEL-BNB.e5179097.png";